import { BsTwitter } from "react-icons/bs";
import {
  QuizHandler,
  QuizMode,
  QuizResultGrade,
  QuizScene,
  encodeQuizResult,
} from "../../lib/quiz/Quiz";
import ResultCrown from "../../img/quizzes/result_crown.png";
import ResultFootprint from "../../img/quizzes/result_footprint.png";

interface Props {
  quizHandler: QuizHandler;
  setQuizScene: React.Dispatch<React.SetStateAction<QuizScene>>;
}

export default function QuizResult({ quizHandler, setQuizScene }: Props) {
  const quizResult = quizHandler.getResult();
  const numQuestions = quizResult.numQuestions;
  const numCorrects = quizResult.numCorrects;
  const grade = quizResult.grade;
  const mode = quizHandler.getCurrentMode();

  const getTweetLink = () => {
    const url = `https://akikunsuki.com/birthday2021/quizzes?p=${encodeQuizResult(
      mode,
      grade
    )}`;
    const text = `アキくんクイズ${modeToText(
      mode
    )}モードで、${numQuestions}問中${numCorrects}問正解！\nあなたは…「${gradeToText(
      grade
    )}」でした。\n#アキくんクイズ 2021\n${url}`;

    const params = new URLSearchParams({ text: text });
    return "http://twitter.com/intent/tweet?" + params.toString();
  };

  const goToModeSelctScene = () => {
    setQuizScene("mode-select");
  };

  const modeToText = (mode: QuizMode) => {
    switch (mode) {
      case "easy":
        return "EASY";
      case "normal":
        return "NORMAL";
      case "hard":
        return "HARD";
      case "expert":
        return "EXPERT";
    }
  };

  const gradeToText = (grade: QuizResultGrade) => {
    switch (grade) {
      case "short":
        return "ショート級";
      case "tall":
        return "トール級";
      case "grande":
        return "グランデ級";
      case "trenta":
        return "トレンタ級";
      case "master":
        return "マスター級";
    }
  };

  const getResultImage = (mode: QuizMode, grade: QuizResultGrade) => {
    const code = encodeQuizResult(mode, grade);
    return `https://asia-northeast1-akikun-birthday2021.cloudfunctions.net/ogp-image-generator/quizzes?p=${code}`;
  };

  return (
    <div className="relative px-3 mt-10 text-center text-gray-800 bg-white rounded-lg py-7">
      <div className="absolute flex items-center justify-center w-full -top-10">
        <img className="w-24" src={ResultCrown} alt="result crown" />
      </div>
      <div className="py-5 text-2xl">
        <div>
          {numQuestions} 問中 {numCorrects} 問正解
        </div>
        <div>あなたは...</div>
        <div className="flex items-center justify-center text-3xl">
          <span className="font-medium">{gradeToText(grade)}</span> です
          <img
            src={ResultFootprint}
            alt="result footprint"
            className="inline-block w-12 p-1"
          />
        </div>
      </div>
      <img
        className="w-full max-w-lg mx-auto mb-6 shadow-lg"
        src={getResultImage(mode, grade)}
        alt="quiz result"
      />
      <div className="m-auto text-base">
        <button
          className="w-20 p-1 mx-1 text-gray-900 bg-gray-200 rounded hover:bg-gray-300"
          onClick={goToModeSelctScene}
        >
          戻る
        </button>
        <button className="mx-1 text-white bg-blue-400 rounded w-36 hover:bg-blue-500">
          <a
            className="inline-block w-full p-1"
            target="_blank"
            rel="noreferrer"
            href={getTweetLink()}
          >
            <BsTwitter /> 結果をツイート
          </a>
        </button>
      </div>
    </div>
  );
}
